const BASE_STATUS_CONFIG = {
  questionnaire: { label: '問診中', color: '#3b82f6', bg: '#eff6ff' },
  doctor_selection: { label: '医師選択', color: '#3b82f6', bg: '#eff6ff' },
  waiting: { label: '診察待ち', color: '#f59e0b', bg: '#fffbeb' },
  in_progress: { label: '診察中', color: '#10b981', bg: '#ecfdf5' },
  doctor_finished: { label: '診察終了', color: '#8b5cf6', bg: '#f5f3ff' },
  record_review_pending: { label: '確認中', color: '#8b5cf6', bg: '#f5f3ff' },
  billing_confirmation_pending: { label: '会計待ち', color: '#f59e0b', bg: '#fffbeb' },
  payment_pending: { label: '支払い待ち', color: '#ef4444', bg: '#fef2f2' },
  delivery_pending: { label: '配送準備中', color: '#06b6d4', bg: '#ecfeff' },
  rx_outside_pending: { label: '院外処方待ち', color: '#0891b2', bg: '#ecfeff' },
  completed: { label: '完了', color: '#10b981', bg: '#ecfdf5' },
  cancelled: { label: 'キャンセル', color: '#6b7280', bg: '#f3f4f6' },
};

const DELIVERY_CONFIG_ACTIONS = ['select_delivery_method', 'select_delivery_address', 'select_pharmacy'];

export function resolveSessionStatus(session = {}, flowState = null) {
  const status = session?.status;
  const nextAction = flowState?.next_action || session?.next_action;
  const hasPendingDeliveryConfig = DELIVERY_CONFIG_ACTIONS.includes(nextAction);

  if (status === 'payment_pending') {
    if (hasPendingDeliveryConfig) {
      return { label: '受け取り設定待ち', color: '#7c3aed', bg: '#f5f3ff' };
    }
  }

  if (status === 'delivery_pending') {
    if (hasPendingDeliveryConfig) {
      return { label: '受け取り設定待ち', color: '#7c3aed', bg: '#f5f3ff' };
    }

    return BASE_STATUS_CONFIG.completed;
  }

  return BASE_STATUS_CONFIG[status] || { label: status || '-', color: '#6b7280', bg: '#f3f4f6' };
}
